/**
 * 权限相关接口
 */

import { fetchApi } from "../interceptor"

/**
 * 天气组件查询接口
 * @returns {Promise<unknown>}
 */
export const queryWeather = () => {
  const url = "engine2/weather/today-v3"
  return fetchApi(url, null, "GET", "params")
}

/**
 * svg查询
 * @param data
 * @returns {Promise<unknown>}
 */
export const querySvg = data => {
  const url = `v2/svg/${data.publicId}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 判断是否有进详情的权限
 * @param data
 * @returns {Promise<unknown>}
 */
export const getDetailPagePermission = data => {
  const url = `engine2/data/api-v2/check/permission`
  return fetchApi(url, data.param, "GET", "params")
}

/**
 * 判断用户在当前网站下的权限+当前应用是否属于这个网站+当前应用的创建时间
 * @param data
 * @returns {Promise<unknown>}
 */
export const getComponentPermission = data => {
  const url = `v2/check-app/${data.appId}`
  return fetchApi(url, null, "GET", "params")
}
// 是否有编辑页访问权限
export const getEditPagePermission = data => {
  const url = `v2/${data.pageId}/permission`
  return fetchApi(url, null, "GET", "params")
}

// 查询权限列表，查询role表，role>10的数据 ，用于2.0组件增删权限判断
export const getPermissionList = () => {
  const url = "v2/list-role"
  return fetchApi(url, null, "GET", "params")
}

/**
 * 获取单个或多个cookie值
 */
export const getCookie = data => {
  const url = `cookie/get?name=${data.name}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 获取用户信息s
 */
export const getUserInfo = data => {
  const url = `engine2/header/user-info?t=${new Date().getTime()}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 获取当前用户个人偏好设置
 */
export const getPreference = data => {
  const url = `v2/preference`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 修改当前用户个人偏好设置
 */
export const updatePreference = data => {
  const url = `v2/update-preference`
  return fetchApi(url, data, "POST", "body")
}

/**
 * 获取当前IP
 */
export const getIP = data => {
  const url = `user/getUserIpAndCheck`
  return fetchApi(url, null, "GET", "params")
}
